import { cn } from '../../lib/cn'

/**
 * Doable brand lockup: geometric logomark (four tiles, one volt) + wordmark
 * set in Google Sans Flex. `tone="light"` inverts for dark surfaces.
 */
export function Logomark({ className, tone = 'dark' }: { className?: string; tone?: 'dark' | 'light' }) {
  return (
    <svg viewBox="0 0 192 192" aria-hidden className={cn('size-6 shrink-0', className)}>
      <rect width="192" height="192" rx="40" className={tone === 'light' ? 'fill-console-foreground' : 'fill-foreground'} />
      <rect x="44" y="44" width="44" height="44" rx="9" className={tone === 'light' ? 'fill-console' : 'fill-background'} />
      <rect x="104" y="44" width="44" height="44" rx="9" className={tone === 'light' ? 'fill-console' : 'fill-background'} />
      <rect x="44" y="104" width="44" height="44" rx="9" className={tone === 'light' ? 'fill-console' : 'fill-background'} />
      <rect x="104" y="104" width="44" height="44" rx="9" className="fill-volt" />
    </svg>
  )
}

export function Wordmark({ className, tone = 'dark', mark = true }: { className?: string; tone?: 'dark' | 'light'; mark?: boolean }) {
  return (
    <span className={cn('inline-flex select-none items-center gap-2', className)}>
      {mark ? <Logomark tone={tone} className="size-6" /> : null}
      <span className={cn('font-heading text-[1.05rem] font-semibold leading-none tracking-tight', tone === 'light' ? 'text-console-foreground' : 'text-foreground')}>Doable</span>
    </span>
  )
}

/** The Applox credit, as doWallet's made-by-applox. */
export function MadeByApplox({ className }: { className?: string }) {
  return <span className={cn('text-xs text-muted-foreground', className)}>Made by Applox GmbH · Dortmund</span>
}
